import { defineComponent as _defineComponent } from 'vue'
import InvoiceSection from '@/views/my-projects/components/invoice/InvoiceSection.vue';
import IconLightBulb from '@/components/svg/profile-lightbulb.svg?inline';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';
import InvoiceAttachmentFileTable from '@/views/my-projects/components/invoice/attachments/InvoiceAttachmentFileTable.vue';
import UploadableItem from '@/components/molecules/UploadableItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoiceAttachments',
  setup(__props) {

const files = [{
  date: '2023-01-01',
  name: 'invoice.pdf',
},
{
  date: '2021-05-03',
  name: 'invoice-2.pdf',
},
{
  date: '2021-01-05',
  name: 'invoice-addition-wrgwerg-werg-wetg-wetgw-erg-werg-wergw-erg-werg-wergwerg-wergw-erg.pdf',
}
];


return { __sfc: true,files, InvoiceSection, IconLightBulb, BCXMarkdown, InvoiceAttachmentFileTable, UploadableItem }
}

})